<template>
  <div>
    <content-panel class="panel-tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
        <el-tab-pane label="店铺权限" name="authorization"></el-tab-pane>
        <el-tab-pane label="清仓店铺" name="clearanceStore"></el-tab-pane>
      </el-tabs>
      <component :is="activeComponent"></component>
    </content-panel>
  </div>
</template>

<script>
import authorization from '../authorization/authorization'
import clearanceStore from '../clearanceStore/clearanceStore'
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  components: { authorization, clearanceStore },
  mixins: [pagePathMixin],
  data() {
    return {
      activeName: null
    }
  },
  computed: {
    activeComponent() {
      return this.activeName
    },
  },
  mounted() {
    this.activeName = 'authorization';
  },
  methods: {
    handleClick() {}
  }
}
</script>

<style lang="stylus" scoped>
.panel-tabs
  >>> .main-area
    padding-top 0
.tabs
  >>> .el-tabs__header
    margin-bottom 5px
</style>